import ConfirmationScreen from "legacy/boater-reservation-flow/price-estimate/dockwa-plus-sign-up/ConfirmationScreen"
import DockwaPlusPurchaseScreen from "legacy/boater-reservation-flow/price-estimate/dockwa-plus-sign-up/DockwaPlusPurchaseScreen"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class DockwaPlusModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentScreen: this.getInitialScreen(props),
      hasMembership: this.props.hasMembership,
    }

    this.goToNextScreen = this.goToNextScreen.bind(this)
  }

  getInitialScreen(props) {
    const {
      user: { activeDockwaPlusSubscription },
    } = props

    if (!activeDockwaPlusSubscription) {
      return "purchase"
    } else {
      return "confirmation"
    }
  }

  goToNextScreen(nextScreen) {
    const {
      state: { fetchV2PriceEstimate },
    } = this.props
    this.setState({ currentScreen: nextScreen }, fetchV2PriceEstimate)
  }

  render() {
    let screenComponent
    const {
      closeModal,
      setGlobalState,
      paymentMethods,
      productInformation,
      user,
    } = this.props

    switch (this.state.currentScreen) {
      case "purchase":
        screenComponent = (
          <DockwaPlusPurchaseScreen
            user={user}
            goToNextScreen={this.goToNextScreen}
            setGlobalState={setGlobalState}
            paymentMethods={paymentMethods}
            productInformation={productInformation}
            closeModal={closeModal}
          />
        )
        break
      case "confirmation":
        screenComponent = (
          <ConfirmationScreen
            user={user}
            onClose={closeModal}
            productInformation={productInformation}
          />
        )
        break
      default:
        screenComponent = null
    }

    return (
      <Modal
        isOpen={this.props.isOpen}
        onClose={closeModal}
        size="default"
        minSize="medium"
        maxSize="medium"
      >
        <Modal.Body>{screenComponent}</Modal.Body>
      </Modal>
    )
  }
}

DockwaPlusModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  hasMembership: PropTypes.bool,
  paymentMethods: PropTypes.array,
  productInformation: PropTypes.object.isRequired,
  routeTo: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  setHeader: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  backdrop: PropTypes.bool,
  isOpen: PropTypes.bool,
}

export default DockwaPlusModal
